module.exports = __webpack_public_path__ + "img/Agencies.e2f8e90e.svg";